var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 194,
    viewBox: "0 0 203 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9673 0.296387H60.4386V9.19065H15.9673V0.296387Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 59.9942V15.5228H9.63499V59.9942H0.740723Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 15.5228C0.740723 11.4845 2.34494 7.61167 5.20048 4.75614C8.05601 1.90061 11.9289 0.296387 15.9673 0.296387V9.18557C14.2865 9.18557 12.6746 9.85325 11.4861 11.0417C10.2976 12.2302 9.6299 13.8422 9.6299 15.5229L0.740723 15.5228Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.52 193.408H143.049V184.514H187.52V193.408Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.747 133.71V178.182H193.853V133.71H202.747Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.747 178.182C202.747 182.22 201.143 186.093 198.287 188.948C195.432 191.804 191.559 193.408 187.52 193.408V184.519C189.201 184.519 190.813 183.851 192.002 182.663C193.19 181.474 193.858 179.862 193.858 178.182L202.747 178.182Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.926 83.5109C153.926 112.33 130.563 162.376 101.744 162.376C72.9242 162.376 49.5613 112.33 49.5613 83.5109C49.5613 54.6913 72.9242 31.3284 101.744 31.3284C130.563 31.3284 153.926 54.6913 153.926 83.5109ZM59.9978 83.5109C59.9978 106.567 78.6881 151.94 101.744 151.94C124.799 151.94 143.49 106.567 143.49 83.5109C143.49 60.4552 124.799 41.7649 101.744 41.7649C78.6881 41.7649 59.9978 60.4552 59.9978 83.5109Z",
    fill: "#F6D694"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9673 193.408H60.4386V184.514H15.9673V193.408Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 133.71V178.182H9.63499V133.71H0.740723Z",
    fill: "#333333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 178.182C0.740723 182.22 2.34494 186.093 5.20048 188.948C8.05601 191.804 11.9289 193.408 15.9673 193.408V184.519C14.2865 184.519 12.6746 183.851 11.4861 182.663C10.2976 181.474 9.6299 179.862 9.6299 178.182L0.740723 178.182Z",
    fill: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M187.52 0.296387H143.049V9.19065H187.52V0.296387Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.747 59.9942V15.5228H193.853V59.9942H202.747Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.747 15.5228C202.747 11.4845 201.143 7.61167 198.287 4.75614C195.432 1.90061 191.559 0.296387 187.52 0.296387V9.18557C189.201 9.18557 190.813 9.85325 192.002 11.0417C193.19 12.2302 193.858 13.8422 193.858 15.5229L202.747 15.5228Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIcon);
export default __webpack_public_path__ + "static/media/dark-icon.d4c584d2adbea203da02fe9244c41b48.svg";
export { ForwardRef as ReactComponent };